// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb6dbedd","455":"51673c87","864":"2581465f"}[chunkId] + ".chunk.js";
};